<template>
  <vs-popup id="impersonate-modal" :active.sync="popupActive" title="Impersonate">
        <div class="vx-row">
            <div class="vx-col w-full mb-4">
                <label>Company</label>
                <v-select
                  v-model="impersonatedCompany"
                  :options="companyOptions"
                  name="impersonated_Company"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
            </div>
            <div class="vx-col w-full">
                <label>Impersonate Active</label>
                <vs-switch v-model="impersonateActive" color="#8145fc"/>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button class="mt-2" color="secondary" @click="login">Login</vs-button>
                </div>
            </div>
        </div>
  </vs-popup>
</template>

<script>
import vSelect from 'vue-select';

export default {
  name: 'Impersonate-Modal',
  components: {
    vSelect,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
        popupActive: false,
        impersonatedCompany: null,
        impersonateActive: false,
        companyOptions: [],
    }
  },
  watch: {
    value: {
      handler(val) {
        this.popupActive = val;
      },
      immediate: true,
    },
    popupActive(val) {
      if (val === false) {
        this.$emit('input', val);
      }
    },
  },
  async created() {
    const user = this.$store.getters['auth/user'];
    this.impersonateActive = user.company.IsImpersonation;

    await this.getCompanyList();
    if (this.impersonateActive) {
      this.impersonatedCompany = {
        label: user.company.CompanyName,
        value: user.company.CompanyID,
      };
    }
  },
  methods: {
    async getCompanyList() {
      try {
        const { data } = await this.$api.impersonate.getCompanyList();
        this.companyOptions = data.data.map((company) => ({
          label: company.DisplayName,
          value: company.CompanyPK,
        }));
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: this.$t('ErrorOccurred'),
          text: 'An error has occured',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right',
        });
      }
    },
    async login() {
      try {
        if (this.impersonateActive && !this.impersonatedCompany) {
          this.$vs.notify({
            title: this.$t('ErrorOccurred'),
            text: 'No company selected',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            position: 'top-right',
          });

          return;
        }

        const { data } = await this.$api.impersonate.updateImpersonate(
          this.impersonateActive,
          this.impersonatedCompany ? this.impersonatedCompany.value : null,
        );
        this.dashboardDetails = data.data;

        this.logout();
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: this.$t('ErrorOccurred'),
          text: 'An error has occured',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right',
        });
      }
    },
    async logout () {
      // if user is logged in via auth0
      await this.$store.dispatch('auth/logout', process.env.VUE_APP_IMPERSONATE_LOGOUT_REDIRECT);
    }
  }
}
</script>

<style lang="scss">
  #impersonate-modal {
    .vs-popup--content {
      overflow: visible;
    }
  }
</style>
